import type { OptionType } from "$components/inputs";
import type { InvoicePayerKind } from "./tokens";

export type InvoiceLineItemRow = {
  id: string;
  name: string;
  dateLabel?: string;
  departmentLabel: string;
  supplierLabel: string;
  quantityLabel: string;
  unitPriceLabel: string;
  amountLabel: string;
  payerLabel: string;
  payerKind: InvoicePayerKind;
};

/** Field paths owned by the draft's form, one set per line. */
export type InvoiceLineItemFieldNames = {
  name: string;
  department: string;
  supplier: string;
  quantity: string;
  payer: string;
};

export type InvoiceLineItemDraftRow = InvoiceLineItemRow & {
  fieldNames: InvoiceLineItemFieldNames;
  payerOptions: OptionType[];
};

export type InvoiceLineItemVariant = "draft" | "finalised";

/**
 * The draft leads with the date because the line is still being assembled; the
 * finalised card trails it behind the priced quantity. Supplier is absent from
 * both — it wraps the line on tablet as readily as on phone.
 */
export const invoiceLineItemMetaLine = ({
  row,
  variant,
  showItemDate,
}: {
  row: InvoiceLineItemRow;
  variant: InvoiceLineItemVariant;
  showItemDate: boolean;
}): string => {
  const date = showItemDate ? row.dateLabel : undefined;
  const priced = `${row.quantityLabel} × ${row.unitPriceLabel}`;

  return (
    variant === "draft"
      ? [date, row.departmentLabel, priced]
      : [row.departmentLabel, `Qty ${priced}`, date]
  )
    .filter(Boolean)
    .join(" · ");
};
